import React from 'react';
import { Container, Typography, Box, IconButton, Link, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Attributions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <Box className="page-header">
        <Box className="title-row">
          <IconButton onClick={() => navigate(-1)} aria-label="go back">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1" className="page-title">Licenses & Attributions</Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>Open Food Facts</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Product data is sourced from{' '}
          <Link href="https://world.openfoodfacts.org" target="_blank" rel="noopener noreferrer" underline="hover">
            Open Food Facts
          </Link>
          , a free, open, collaborative database of food products from around the world.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Open Food Facts data is available under the{' '}
          <Link href="https://opendatacommons.org/licenses/odbl/1.0/" target="_blank" rel="noopener noreferrer" underline="hover">
            Open Database License (ODbL)
          </Link>
          . Product images may be subject to copyright.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Google Services</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          This application uses{' '}
          <Link href="https://developers.google.com/maps" target="_blank" rel="noopener noreferrer" underline="hover">
            Google Maps Platform
          </Link>
          {' '}for location services and mapping functionality, and{' '}
          <Link href="https://www.google.com/recaptcha" target="_blank" rel="noopener noreferrer" underline="hover">
            Google reCAPTCHA
          </Link>
          {' '}for spam protection.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Use of Google services is subject to{' '}
          <Link href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" underline="hover">
            Google Terms of Service
          </Link>
          {' '}and{' '}
          <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" underline="hover">
            Privacy Policy
          </Link>
          .
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Open Source Libraries</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          This application is built with open source software. Key libraries include:
        </Typography>
        <Typography variant="body2" color="text.secondary" component="div">
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li>
              <Link href="https://reactjs.org" target="_blank" rel="noopener noreferrer" underline="hover">React</Link>
              {' '}- MIT License
            </li>
            <li>
              <Link href="https://mui.com" target="_blank" rel="noopener noreferrer" underline="hover">Material-UI</Link>
              {' '}- MIT License
            </li>
            <li>
              <Link href="https://tesseract.projectnaptha.com" target="_blank" rel="noopener noreferrer" underline="hover">Tesseract.js</Link>
              {' '}- Apache 2.0 License
            </li>
            <li>
              <Link href="https://serratus.github.io/quaggaJS" target="_blank" rel="noopener noreferrer" underline="hover">QuaggaJS</Link>
              {' '}- MIT License
            </li>
          </ul>
        </Typography>
      </Box>

    </Container>
  );
};

export default Attributions;
